module.exports = __webpack_public_path__ + "img/icon-user-request.17daae58.svg";